import React, { useEffect, useState } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import "../../../styles/Form.css";
import { MODE } from "../../../constants/SiteConstants";
import axios from "axios";
import { generateSlug } from "../../../utils/commonFunc";
import { toast } from "react-toastify";
import 'react-quill/dist/quill.snow.css';

const CompanyForm = ({
  fields,
  onSubmit,
  mode,
  initialData = {},
  selectedType,
  handleImageChange,
  imagePreview,
  onTypeChange,
  onAddMulti = false,
  passOptionsinString = false,
  showOptionsinEditMode = false,
}) => {
  const [formData, setFormData] = useState({});
  const [errors, setErrors] = useState({});
  const [dropdownOptions, setDropdownOptions] = useState([{ value: "" }]);
  const [showHtml, setShowHtml] = useState(false);
  useEffect(() => {
    if (initialData && mode === MODE.UPDATE) {
      setFormData({
        ...initialData,
        options: initialData.options || [],
      });

      if (initialData.options && selectedType === MODE.DROPDOWN) {
        const modifiedOptions = passOptionsinString
          ? initialData.options.map((option) => option)
          : initialData.options.map((option) => ({ value: option.value }));

        setDropdownOptions(modifiedOptions);
      }
    }
  }, [initialData, mode]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => {
      const updatedData = {
        ...prevData,
        [name]: value,
      };

      // Auto-generate slug if the field is title or name
      if (name === "title" || name === "name") {
        updatedData.slug = generateSlug(value);
      }

      return updatedData;
    });

    if (errors[name]) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: undefined,
      }));
    }

    if (onAddMulti && onTypeChange) {
      onTypeChange(value);
    }
  };

  const handleQuillChange = (name, value) => {
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    if (errors[name]) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: undefined,
      }));
    }
  };

  const addOption = () => {
    if (showOptionsinEditMode) {
      setDropdownOptions([...dropdownOptions, ""]);
    } else {
      setDropdownOptions([...dropdownOptions, { value: "" }]);
    }
  };

  const removeOption = (index) => {
    const updatedOptions = dropdownOptions.filter((_, idx) => idx !== index);
    setDropdownOptions(updatedOptions);
  };

  const handleOptionChange = (index, value) => {
    const updatedOptions = dropdownOptions.map((option, idx) =>
      idx === index ? (passOptionsinString ? value : { value }) : option
    );
    setDropdownOptions(updatedOptions);
  };

  const validateForm = () => {
    let formErrors = {};

    fields.forEach((field) => {
      const value = formData[field.name];

      if (field.required && !value) {
        formErrors[field.name] = `${field.label} is required`;
      }

      if (field.name === "description" && value) {
        const strippedValue = value.replace(/<[^>]+>/g, "").trim();
        if (!strippedValue) {
          formErrors[field.name] = "Description is required";
        }
      }

      if (field.name === "phoneNumber" && value) {
        const phoneRegex = /^[0-9]{10}$/;
        if (!phoneRegex.test(value)) {
          formErrors[
            field.name
          ] = `${field.label} must be a valid 10 digits number`;
        }
      }
    });

    setErrors(formErrors);
    return Object.keys(formErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/company/getAllCompany`,
        { params: { slug: formData.slug } }
      );
      const existingSlugs = response.data.data.map((company) => company.slug);

      if (existingSlugs.includes(formData.slug)) {
        toast.error("Slug must be unique")
        return;
      }
    } catch (error) {
      toast.error("Error checking slug. Please try again.")
    }

    if (validateForm()) {
      const updatedFormObj = {
        ...formData,
        options: dropdownOptions,
      };
      onSubmit(onAddMulti ? updatedFormObj : formData);
    }
  };
  const modules = {
    toolbar: [
      [{ 'header': '1' }, { 'header': '2' }, { 'font': [] }],
      [{ 'size': ['small', 'medium', 'large', 'huge'] }],
      [{ 'align': [] }],
      ['bold', 'italic', 'underline', 'strike'],
      [{ 'list': 'ordered' }, { 'list': 'bullet' }],
      [{ 'indent': '-1' }, { 'indent': '+1' }],
      ['link', 'image', 'video'],
      [{ 'color': [] }, { 'background': [] }],
      ['code-block'],
    ],
  };

  return (
    <div className="rounded-sm  bg-white">
      <div className="flex flex-col gap-5.5 p-6.5">
        <form className="form-container" onSubmit={handleSubmit}>
          {fields.map((field) => (
            <div className="form-group" key={field.name}>
              <label htmlFor={field.name} className="mb-3 block text-[#444]">
                {field.label}
              </label>
              {field.type === "file" ? (
                <>
                  <input
                    type="file"
                    className="w-full rounded-md border border-stroke p-3 outline-none file:mr-4 file:rounded file:border-[0.5px] file:border-stroke file:bg-[#EEEEEE] file:py-1 file:px-2.5 file:text-sm"
                    id={field.name}
                    name={field.name}
                    onChange={handleImageChange}
                    multiple
                  />
                  {imagePreview && imagePreview.length > 0 && (
                    <div
                      style={{
                        display: "flex",
                        gap: "10px",
                        marginTop: "10px",
                      }}
                    >
                      {imagePreview.map((preview, index) => (
                        <img
                          key={index}
                          src={preview}
                          alt="Preview"
                          style={{ width: "100px", height: "100px", objectFit: "contain", display: "block" }}
                        />
                      ))}
                    </div>
                  )}
                </>
              ) : field.type === "rich-text" ? (
                <div className="mt-4">
                  <div className="flex justify-end mb-2">
                    <button
                      type="button"
                      onClick={() => setShowHtml(!showHtml)}
                      className="text-sm text-blue-600 hover:underline"
                    >
                      {showHtml ? 'Switch to Editor' : 'View HTML'}
                    </button>

                  </div>

                  {showHtml ? (
                    <textarea
                      value={formData[field.name] || ""}
                      onChange={(e) => handleQuillChange(field.name, e.target.value)}
                      className="w-full h-64 p-2 border border-gray-300 rounded font-mono text-sm"
                    />
                  ) : (
                    <ReactQuill
                      value={formData[field.name] || ""}
                      onChange={(value) => handleQuillChange(field.name, value)}
                      placeholder={field.placeholder}
                      className="mt-2"
                      modules={modules}
                    />
                  )}
                </div>
              ) : field.type === "select" ? (
                <select
                  className="w-full rounded-lg border-[1.5px] border-stroke bg-transparent py-3 px-5 text-black outline-none transition focus:border-ring-blue-500 active:border-ring-blue-500"
                  id={field.name}
                  name={field.name}
                  value={formData[field.name] || ""}
                  onChange={handleChange}
                >
                  <option value="" disabled>
                    {field.placeholder || "Please select an option"}
                  </option>
                  {field.options.map((option) => (
                    <option key={option.value} value={option.value}>
                      {option.name}
                    </option>
                  ))}
                </select>
              ) : (
                <input
                  type={
                    field.name === "phoneNumber"
                      ? "number"
                      : field.type || "text"
                  }
                  className="w-full rounded-lg border-[1.5px] bg-transparent py-3 px-5 text-black outline-none transition focus:border-blue-500 focus:ring-blue-500 focus:outline-none"
                  id={field.name}
                  name={field.name}
                  placeholder={field.placeholder}
                  value={
                    field.name === "phoneNumber"
                      ? formData[field.name]?.replace(/^\+91/, "")
                      : formData[field.name] || ""
                  }
                  onChange={handleChange}
                />
              )}
              {errors[field.name] && (
                <p className="error-text text-red-500">{errors[field.name]}</p>
              )}
            </div>
          ))}
          {selectedType === MODE.DROPDOWN && (
            <div className="form-group">
              <label className="mb-3 block text-black">Dropdown Options</label>
              {dropdownOptions.map((option, index) => (
                <div
                  key={index}
                  style={{ display: "flex", alignItems: "baseline" }}
                >
                  <div className="form-group" style={{ width: "92%" }}>
                    <input
                      type="text"
                      className="w-full rounded-lg border-[1.5px] bg-transparent py-3 px-5 text-black outline-none transition ffocus:border-blue-500 focus:ring-blue-500 focus:outline-none"
                      placeholder={`Option ${index + 1}`}
                      value={showOptionsinEditMode ? option : option.value}
                      onChange={(e) =>
                        handleOptionChange(index, e.target.value)
                      }
                    />
                  </div>
                  <div
                    onClick={() => removeOption(index)}
                    className="text-[#444] cursor-pointer ml-[10px]"
                  >
                    <svg
                      className="fill-current"
                      width="18"
                      height="18"
                      viewBox="0 0 18 18"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M13.7535 2.47502H11.5879V1.9969C11.5879 1.15315 10.9129 0.478149 10.0691 0.478149H7.90352C7.05977 0.478149 6.38477 1.15315 6.38477 1.9969V2.47502H4.21914C3.40352 2.47502 2.72852 3.15002 2.72852 3.96565V4.8094C2.72852 5.42815 3.09414 5.9344 3.62852 6.1594L4.07852 15.4688C4.13477 16.6219 5.09102 17.5219 6.24414 17.5219H11.7004C12.8535 17.5219 13.8098 16.6219 13.866 15.4688L14.3441 6.13127C14.8785 5.90627 15.2441 5.3719 15.2441 4.78127V3.93752C15.2441 3.15002 14.5691 2.47502 13.7535 2.47502ZM7.67852 1.9969C7.67852 1.85627 7.79102 1.74377 7.93164 1.74377H10.0973C10.2379 1.74377 10.3504 1.85627 10.3504 1.9969V2.47502H7.70664V1.9969H7.67852ZM4.02227 3.96565C4.02227 3.85315 4.10664 3.74065 4.24727 3.74065H13.7535C13.866 3.74065 13.9785 3.82502 13.9785 3.96565V4.8094C13.9785 4.9219 13.8941 5.0344 13.7535 5.0344H4.24727C4.13477 5.0344 4.02227 4.95002 4.02227 4.8094V3.96565ZM11.7285 16.2563H6.27227C5.79414 16.2563 5.40039 15.8906 5.37227 15.3844L4.95039 6.2719H13.0785L12.6566 15.3844C12.6004 15.8625 12.2066 16.2563 11.7285 16.2563Z"
                        fill=""
                      />
                      <path
                        d="M9.00039 9.11255C8.66289 9.11255 8.35352 9.3938 8.35352 9.75942V13.3313C8.35352 13.6688 8.63477 13.9782 9.00039 13.9782C9.33789 13.9782 9.64727 13.6969 9.64727 13.3313V9.75942C9.64727 9.3938 9.33789 9.11255 9.00039 9.11255Z"
                        fill=""
                      />
                      <path
                        d="M11.2502 9.67504C10.8846 9.64692 10.6033 9.90004 10.5752 10.2657L10.4064 12.7407C10.3783 13.0782 10.6314 13.3875 10.9971 13.4157C11.0252 13.4157 11.0252 13.4157 11.0533 13.4157C11.3908 13.4157 11.6721 13.1625 11.6721 12.825L11.8408 10.35C11.8408 9.98442 11.5877 9.70317 11.2502 9.67504Z"
                        fill=""
                      />
                      <path
                        d="M6.72245 9.67504C6.38495 9.70317 6.1037 10.0125 6.13182 10.35L6.3287 12.825C6.35683 13.1625 6.63808 13.4157 6.94745 13.4157C6.97558 13.4157 6.97558 13.4157 7.0037 13.4157C7.3412 13.3875 7.62245 13.0782 7.59433 12.7407L7.39745 10.2657C7.39745 9.90004 7.08808 9.64692 6.72245 9.67504Z"
                        fill=""
                      />
                    </svg>
                  </div>
                </div>
              ))}
              <button
                type="button"
                className="mt-4 px-[10px] rounded-lg bg-[#1C2434] text-white py-3 hover:bg-[#1C2434]"
                onClick={addOption}
              >
                Add Option
              </button>
            </div>
          )}
          <button
            type="submit"
            className="mt-4 w-full rounded-lg bg-[#1C2434] text-white py-3 hover:bg-[#1C2434]"
          >
            {mode === MODE.ADD ? "Add" : "Update"} Data
          </button>
        </form>
      </div>
    </div>
  );
};

export default CompanyForm;
